import React, { useEffect, useState } from "react";
import axios from "axios";
import { Questionnaire } from "./Questionnaire";
import { base_url } from "../Auth/BackendAPIUrl";
import Load from "../../Images/Bundles/load_sticker.webp";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { questionnaireAction1, questionnaireTitle } from "../../Redux/Action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ConfigToken } from "../Auth/ConfigToken";
import useToastMessage from "../Pages/Toaster/Toaster";
import { Toaster } from "react-hot-toast";
import { fetchQuestionAnswer, updateOrderID } from "./questionnaire.slice";
import { handleAutoResize } from "./useAutoResize";

export const Questionnaire1 = ({
  formData,
  setFormData,
  changeLang,
  setChangeLang,
  lang,
  setlang,
}) => {
  const { showErrorToast } = useToastMessage();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [formData, setFormData] = useState();
  const [errors, setErrors] = useState({});
  // const [activeType, setActiveType] = useState(null);
  const [isFilled, setIsFilled] = useState(null);

  /* NEW QUESTIONANSWER */

  const questionAndAnswers = useSelector(
    (state) => state?.questionAnswer?.questionAndAnswers || []
  );

  const orderId = useSelector((state) => state?.questionAnswer?.orderId);
  const [questionAnswer1, setQuestionAnswer1] = useState([]);

  useEffect(() => {
    if (questionAndAnswers.length > 0) {
      setQuestionAnswer1(questionAndAnswers);
    }
  }, [questionAndAnswers]);

  // Helper function to filter out duplicate questions across categories
  const filterDuplicateQuestions = (questions, currentCategory) => {
    // Get all questions that have been answered (have a non-empty answer)
    const answeredQuestionIds = questionAndAnswers
      .filter(q => {
        const answer = q.answer;
        if (!answer) return false;
        if (typeof answer === "string" && answer.trim() !== "") return true;
        if (Array.isArray(answer) && answer.length > 0) return true;
        if (typeof answer === "object" && !Array.isArray(answer) && Object.keys(answer).length > 0) return true;
        return false;
      })
      .map(q => q.id);

    // Filter questions: exclude if already answered AND appears in multiple categories
    return questions.filter(q => {
      const isAnswered = answeredQuestionIds.includes(q.id);
      const categories = q.category?.split(',') || [];
      const hasMultipleCategories = categories.length > 1;
      
      // If question is answered and has multiple categories, exclude it from other categories
      if (isAnswered && hasMultipleCategories) {
        // Check if this question was answered in a different category
        const answeredQuestion = questionAndAnswers.find(aq => aq.id === q.id);
        if (answeredQuestion) {
          const answeredCategories = answeredQuestion.category?.split(',') || [];
          // If current category is not in the answered categories, exclude it
          return answeredCategories.includes(currentCategory);
        }
      }
      return true;
    });
  };

  /* NEW QUESTIONANSWER */

  // ${location.state.orderId}

  useEffect(() => {
    if (location?.state?.orderId) {
      dispatch(updateOrderID(location?.state?.orderId));
    }
  }, [location?.state?.orderId]);

  const placeHolders = [
    "Project Name",
    "(ex:Fashion,Food,Services,Personal Brand,etc...)",
    "(ex:Riyadh , Saudi Arabia)",
    "List them here...",
    "(ex:Best quality, unique design)",
    "Type your website URL",
    "Share your social media link",
  ];

  const placeHolders_arabic = [
    "بندل",
    "الأزياء، المطاعم، الخدمات..الخ",
    "الرياض، السعودية",
    "اكتبهم هنا...",
    "الخامة، الأسعار، التصاميم...الخ",
    "أدخل رابط موقعك الإلكتروني",
    "شارك روابط حساباتك على السوشال ميديا",
  ];

  const showToastMessage = () => {
    if (!toast.isActive("required-value-toast")) {
      showErrorToast(
        changeLang === "ar" ? "القيمة مطلوب" : "The Value is required!",
        "#D83D99"
      );
    }
  };
  const handleTypeClick = (questionId, type, ans) => {
    setQuestionAnswer1((prev) =>
      prev.map((ele) =>
        ele.id === questionId
          ? {
              ...ele,
              answer: {
                type: type,
                answer: ans,
              },
            }
          : ele
      )
    );
  };

  // URL validation function - checks if the entered value is already a valid URL
  const isValidUrl = (urlString) => {
    if (!urlString || urlString.trim() === "") {
      return false;
    }
      const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/i;
      return urlPattern.test(urlString);
  };

  const countWords = (str) => {
    if (!str || typeof str !== "string") return 0;
    return str.trim().split(/\s+/).filter((word) => word.length > 0).length;
  };

  const handleInputChange = (questionId, value) => {
    if (questionId == "2" || questionId == "3") {
      if (/[0-9!@#$%^&*(),.?":{}|<>]/g.test(value)) {
        setErrors((prev) => ({
          ...prev,
          [questionId]:
            lang === "ar"
              ? "لا يجب أن يحتوي على أرقام أو رموز"
              : "Should not contain numbers or special characters",
        }));
        return;
      } else {
        let temp_err = errors;
        delete temp_err[questionId];
        setErrors(temp_err);
      }
    }
    // Validate question6 (ID 6) as URL
    if (questionId == 6 || questionId === "6") {
      if (value && value.trim() !== "") {
        if (!isValidUrl(value)) {
          setErrors((prev) => ({
            ...prev,
            [questionId]:
              changeLang === "ar"
                ? "يرجى إدخال رابط صحيح"
                : "Please enter a valid URL",
          }));
        } else {
          setErrors((prev) => {
            const updated = { ...prev };
            delete updated[questionId];
            return updated;
          });
        }
      } else {
        // Clear error if field is empty (required validation will handle it)
        setErrors((prev) => {
          const updated = { ...prev };
          delete updated[questionId];
          return updated;
        });
      }
    }
    if (countWords(value) > 70) {
      setErrors((prev) => ({
        ...prev,
        [questionId]:
          lang === "ar"
            ? "يجب ألا يتجاوز النص 70 كلمة"
            : "Text should not exceed 70 words",
      }));
    } else {
      setErrors((prev) => {
        const updated = { ...prev };
        // Only delete word limit error, keep others if any? 
        // Actually, handleInputChange usually clears errors for the field if it's valid.
        // But let's be careful.
        if (updated[questionId] === (lang === "ar" ? "يجب ألا يتجاوز النص 70 كلمة" : "Text should not exceed 70 words")) {
            delete updated[questionId];
        }
        return updated;
      });
    }

    if (questionId == 4 || questionId === "4") {
      setQuestionAnswer1((prev) =>
        prev.map((ele) => {
          if (ele.id !== questionId) return ele;

          // Check if `type` is selected first
          if (!ele.answer?.type || ele.answer.type.trim() === "") {
            // Show error and skip updating the answer
            setErrors((prev) => ({
              ...prev,
              [questionId]:
                'Please select either "Product" or "Service" first.',
            }));
            return ele; // return original without updating
          }
          // If type is selected, update the answer
          setErrors((prev) => {
            const updated = { ...prev };
            if (updated[questionId] === 'Please select either "Product" or "Service" first.') {
                 delete updated[questionId];
            }
            return updated;
          });

          return {
            ...ele,
            answer: {
              ...ele.answer,
              answer: value,
            },
          };
        })
      );

      // Now handle validation
      if (!value) {
        setErrors((prev) => ({
          ...prev,
          [questionId]:
            lang === "ar"
              ? 'يرجى اختيار "منتج" أو "خدمة" أولاً.'
              : 'Please select either "Product" or "Service" first.',
        }));
      }

      return;
    } else {
      setQuestionAnswer1((prev) =>
        prev.map((ele) =>
          ele.id === questionId ? { ...ele, answer: value } : ele
        )
      );
    }
  };

  const validateFields = () => {
    // Check for word count limit on all fields
    const wordLimitExceeded = questionAnswer1.some((q) => {
      const val = q.answer_type === "brand" ? q.answer?.answer : q.answer;
      return countWords(val) > 70;
    });

    if (wordLimitExceeded) {
       const questionWithLimitError = questionAnswer1.find((q) => {
         const val = q.answer_type === "brand" ? q.answer?.answer : q.answer;
         return countWords(val) > 70;
       });
       if (questionWithLimitError) {
         setErrors((prev) => ({
           ...prev,
           [questionWithLimitError.id]: lang === "ar" ? "يجب ألا يتجاوز النص 70 كلمة" : "Text should not exceed 70 words",
         }));
         setIsFilled(questionWithLimitError.id);
         const element = document.getElementById(`question_${questionWithLimitError.id}`);
         if (element) {
           element.scrollIntoView({ behavior: "smooth" });
         }
       }
       return false;
    }

    // First check for URL validation errors in question6
    const question6 = questionAnswer1.find((q) => q?.id === 6 || q?.id === "6");
    if (question6) {
      const answer = typeof question6.answer === "string" ? question6.answer.trim() : "";
      // If question6 has a value, it must be a valid URL
      if (answer && answer !== "") {
        if (!isValidUrl(answer)) {
          setErrors((prev) => ({
            ...prev,
            [question6.id]:
              changeLang === "ar"
                ? "يرجى إدخال رابط صحيح"
                : "Please enter a valid URL",
          }));
          setIsFilled(question6.id);
          const element = document.getElementById(`question_${question6.id}`);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
          if (!toast.isActive("required-value-toast")) {
            showToastMessage();
          }
          return false;
        }
      }
      // If question6 is required and empty
      if (question6.required && (!answer || answer === "")) {
        setIsFilled(question6.id);
        const element = document.getElementById(`question_${question6.id}`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
        if (!toast.isActive("required-value-toast")) {
          showToastMessage();
        }
        return false;
      }
    }

    // Check for any existing errors
    if (errors && Object.keys(errors).length > 0) {
      const firstErrorQuestionId = Object.keys(errors)[0];
      setIsFilled(firstErrorQuestionId);
      const element = document.getElementById(`question_${firstErrorQuestionId}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
      if (!toast.isActive("required-value-toast")) {
        showToastMessage();
      }
      return false;
    }

    const unansweredRequiredQuestions = questionAnswer1
      .slice(0, 6).sort((a, b)=> a.sort_order - b.sort_order)
      .filter((q) => {
        if (q?.id === 4 && q.required) {
          const type = q?.answer?.type?.trim?.();
          const answer = q?.answer?.answer?.trim?.();
          if (!type && !answer) {
            return true;
          }
          return !type || !answer;
        }
        return (
          q.required &&
          (!q.answer ||
            (typeof q.answer === "string" && q.answer.trim() === ""))
        );
      });

    if (unansweredRequiredQuestions.length > 0) {
      const element = document.getElementById(
        `question_${unansweredRequiredQuestions[0]?.id}`
      );
      setIsFilled(unansweredRequiredQuestions[0]?.id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
      if (!toast.isActive("required-value-toast")) {
        showToastMessage();
      }
      return false;
    }

    return true;
  };

  const onNextClick = (e) => {
    e.stopPropagation();
    if (!validateFields()) {
      return;
    } else {
      dispatch(fetchQuestionAnswer(questionAnswer1));

      navigate(`/questionnaire/${2}`);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  let newUpdatedAns = questionAnswer1.map((ele) => {
    return {
      id: ele.id,
      answers: ele.answer,
    };
  });

  const onSaveLaterClick = async () => {
    let data = {
      answers: newUpdatedAns,
      orderId: orderId,
      status: "not submitted",
    };
    try {
      const response = await axios.post(
        `${base_url}/api/questionnaire/create`,
        data,
        ConfigToken()
      );
      if (response.status === 200) {
        navigate("/dashboard", {
          state: {
            orderId: location.state?.orderId,
          },
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
<div style={{ overflowX: "hidden" }}>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      <ToastContainer />
      <Questionnaire
        Qlang={changeLang}
        setQLang={setChangeLang}
        pageNo={1}
        storeAnswers={location.state?.questionnaireData1}
        orderId={location.state?.orderId}
        bgTitle={changeLang === "ar" ? "أساسيات المشروع" : "Project Basics"}
        formData={formData}
        setFormData={setFormData}
        onNextClick={onNextClick}
        onSaveLaterClick={onSaveLaterClick}
        questions={filterDuplicateQuestions(questionAnswer1.filter(f => f.category.split(',').includes('business')), 'business').sort((a, b) => a.sort_order - b.sort_order).map((question, index) => {
          return (
            <div
              className="questions"
              key={index}
              id={`question_${question.id}`}
            >
              <p
                className={`questions-title xs:w-[90%] sm:w-full md:w-full mx-auto ${
                  index === 0 ? "mt-[1%]" : "mt-[3%]"
                }`}
              >
                {changeLang === "ar"
                  ? question.question_arabic
                  : question.question}
                {question.required && (
                  <span>
                    <sup>*</sup>
                  </span>
                )}
              </p>
              {question.answer_type === "brand" && (
                <div
                  style={{ display: "flex", gap: "10px", marginBottom: "3%" }}
                >
                  <button
                    className={`product-btn ${
                      question?.answer?.type === "product" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleTypeClick(
                        question?.id,
                        "product",
                        question?.answer?.answer
                      );
                    }}
                  >
                    {changeLang === "ar" ? "منتج" : "Product"}
                  </button>
                  <button
                    className={`service-btn ${
                      question?.answer?.type === "service" ? "active" : ""
                    }`}
                    onClick={() =>
                      handleTypeClick(
                        question.id,
                        "service",
                        question?.answer?.answer
                      )
                    }
                  >
                    {changeLang === "ar" ? "خدمة" : "Service"}
                  </button>
                </div>
              )}
              <textarea
                className={`question-input ${
                  isFilled === question?.id
                    ? "border-[#D83D99] border-b-[2px]"
                    : window?.innerWidth <= 475
                    ? "border-b-[1px] border-black"
                    : "border-b-[2px] border-black"
                }`}
                placeholder={
                  changeLang === "ar"
                    ? placeHolders_arabic[index]
                    : placeHolders[index]
                }
                value={
                  question?.answer_type === "brand"
                    ? question?.answer?.answer
                    : question?.answer
                }
                onChange={(e) => {
                  handleInputChange(question.id, e.target.value);
                  handleAutoResize(e, 200);
                }}
                onInput={(e) => handleAutoResize(e, 200)}
                rows={1}
              />
              <div className={`word-counter ${countWords(question?.answer_type === "brand" ? question?.answer?.answer : question?.answer) > 70 ? "limit-exceeded" : ""}`}>
                {changeLang === "ar" ? "كلمات" : "Words"}: {countWords(question?.answer_type === "brand" ? question?.answer?.answer : question?.answer)} / 70
              </div>
              {question.id in errors && (
                <p className="text-[#D83D99]">{errors[question.id]}</p>
              )}
              {index === 0 && window.innerWidth >= 500 ? (
                <div className="img-rotate-qf">
                  <img className="rotating-image" src={Load} alt="Loading" />
                </div>
              ) : (
                ""
              )}
            </div>
          );
        })}
      ></Questionnaire>
    </div>
  );
};
